import { type FC, useCallback } from 'react';
import { Radio } from 'antd';
import type { RadioChangeEvent } from 'antd';
import { usePlanDetailsContext } from './context/PlanDetailsContext';

interface PlanViewHeaderProps {
    planId: string;
    planName: string;
}

const PlanViewHeader: FC<PlanViewHeaderProps> = ({ planId, planName }) => {
    const { activeView, setActiveView } = usePlanDetailsContext();

    const radioValue = activeView === 'metric-view' ? 'metric-view' : 'calendar';

    const handleChange = useCallback(
        (e: RadioChangeEvent) => {
            const next = e.target.value as 'calendar' | 'metric-view';
            setActiveView(next);
        },
        [setActiveView],
    );

    return (
        <div className="flex flex-row justify-start items-center gap-x-4">
            <p className="text-xl font-medium truncate max-w-[200px]">{planName || planId}</p>
            <Radio.Group value={radioValue} onChange={handleChange}>
                <Radio.Button value="calendar">{'Calendar View'}</Radio.Button>
                <Radio.Button value="metric-view">{'Metric View'}</Radio.Button>
            </Radio.Group>
        </div>
    );
};

PlanViewHeader.displayName = 'PlanViewHeader';
export default PlanViewHeader;
